export const UnleashEndpoints = {
    getStatus(name) {
        return `${process.env.API_CLUB_CONTENT}/public/v1/toggles/${name}/status`;
    }
};
